module.exports = __webpack_public_path__ + "v294910/img/search.5884a050.png";